export default {
  methods: {
    imageUrl: function (src, params = {}) {
      if (!src) { return "" }
      let { size } = params
      size === undefined ? (size = "50x") : null
      return src.replace(/\.(jpg|gif).+/, `_${size}.$1`)
    }
  },
}